export function applyPrecision(v: number, precision: number) {

  return + v.toFixed(precision);
}